import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import PageHeader from '../../PageHeader/PageHeader';
import ClickUpdatePaymentContainer from '../../../redux/containers/ClickUpdatePaymentContainer';
import ClickSubmitButtonContainer from '../../../redux/containers/ClickSubmitButtonContainer';

class UpdatePayment extends React.Component {

  componentWillMount() {
    // forces redirect to /login if unauthorized
    if (window.paymarkPlugin !== undefined) {
      location.reload();
    } else {
      this.props.checkSession();
    }
    // this.props.checkSession();
  }


  render() {
    return (
      <main>
        <PageHeader title={'Change Card Details'} />
        <section className="section-half-margin">
          <div className="container gray-container">
            <div className="row">
              <div className="col-sm-12">
                <h4 className="gray-container-title heading-underline">Payment details</h4>
                {
                  window.paymarkPlugin === undefined && <ClickUpdatePaymentContainer />
                }
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 relative">
                <ClickSubmitButtonContainer />
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container">
            <div className="row">
              <div className="col-xs-12 centre">
                <Link className="underline" to="/dashboard">Cancel</Link>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

UpdatePayment.propTypes = {
  checkSession: PropTypes.func
};

export default UpdatePayment;



/** WEBPACK FOOTER **
 ** ./src/components/myaccount/UpdatePayment/UpdatePayment.js
 **/